<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <h3 class="page-header">My MAC Addresses</h3>
        </div>
    </div>
    <div class="row">
      <div class="col-xs-11">
        <form novalidate #macgridForm="ngForm">
          <aims-common-table
            id="mac-table"
            [dataSource]="macAddresses | async"
            [header]="tableHeader"
            [permissions]="tablePermissions"
            [pageSize]="10"
            [addRowInitialObject]="defaultMac"
            (rowAdded)="handleRowAdd($event)"
            (rowUpdated)="handleRowUpdate($event)"
            (rowDeleted)="handleRowDelete($event)"
            [stickyHeader]="true">

            <aims-common-table-dynamic-row id="macAddress">
               <ng-template viewMode let-element style="width:70px">
                 {{ element.macAddress }}
               </ng-template>

              <ng-template editMode let-element let-dynamicControl="dynamicControl">
                <mat-form-field appearance="fill" class="editable-text-field">
                <input matInput [formControl]="dynamicControl" mask="AA:AA:AA:AA:AA:AA" name="mac"
                  [ngModel]="element.macAddress"
                  [patterns]="macRule2"
                  >
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>
        </form>
      </div>
    </div>
    <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
